import * as React from "react";
import { forwardRef } from "react";
const SvgMagnifyingGlass = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M10.66 10.01 7.62 6.97a3.48 3.48 0 0 0-.3-4.63 3.49 3.49 0 0 0-4.98 0 3.49 3.49 0 0 0 0 4.97 3.49 3.49 0 0 0 4.63.3L10 10.67a.1.1 0 0 0 .1.02.1.1 0 0 0 .04-.02l.5-.51a.1.1 0 0 0 .03-.1.1.1 0 0 0-.02-.04ZM6.68 6.68a2.61 2.61 0 0 1-3.7 0 2.61 2.61 0 0 1 0-3.7 2.61 2.61 0 0 1 3.7 0 2.61 2.61 0 0 1 0 3.7Z"
}));
const ForwardRef = forwardRef(SvgMagnifyingGlass);
export default ForwardRef;
